import React from 'react';
import { useField } from 'react-final-form';
import {
  FormControl, FormErrorMessage, FormHelperText, Input,
} from '@chakra-ui/react';
import usePlatforms from '../../hooks/usePlatforms';
import FieldLabel from './FieldLabel';

// item 597 (REVERSES 578) — Platform now lives ON the document chain (proposal → WO →
// invoice), NOT the project. This field binds to the document's OWN `platform` value and
// saves through the normal form save (no write-through to the project). Pick an existing
// platform or type a new one — a typed-new name lands in the managed Platforms list
// server-side (item-302 get-or-create). Required on a proposal + a standalone work order.
const DocumentPlatformField: React.FC<{ isRequired?: boolean; helperText?: string }> = ({
  isRequired = true,
  helperText,
}) => {
  const { input, meta } = useField('platform');
  const { data: platforms } = usePlatforms();
  return (
    <FormControl isInvalid={!!(meta.error && meta.touched)} isRequired={isRequired}>
      <FieldLabel htmlFor="platform">Platform</FieldLabel>
      <Input
        {...input}
        id="platform"
        list="document-platform-options"
        placeholder="Pick or type a platform"
        autoComplete="off"
      />
      <datalist id="document-platform-options">
        {(platforms ?? []).map((name) => <option key={name} value={name} label={name} />)}
      </datalist>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  );
};

DocumentPlatformField.defaultProps = { isRequired: true, helperText: undefined };

export default DocumentPlatformField;
